var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsorStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L7.59118 3.33493C6.78062 5.25367 5.25367 6.78062 3.33493 7.59118L0 9L3.33493 10.4088C5.25367 11.2194 6.78062 12.7463 7.59118 14.6651L9 18L10.4088 14.6651C11.2194 12.7463 12.7463 11.2194 14.6651 10.4088L18 9L14.6651 7.59118C12.7463 6.78062 11.2194 5.25367 10.4088 3.33493L9 0Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorStar);
export default __webpack_public_path__ + "static/media/sponsor-star.e0d201e895e138c582d3a97cbdc147ce.svg";
export { ForwardRef as ReactComponent };